export type Language = 'English'
    | 'Russian'
    | 'Spanish'
    | 'German';


export function localeToLanguage(locale: string | null): [string, Language] {
    const localeParts = locale?.toLowerCase()?.split(/[_-]/);
    locale = localeParts ? localeParts[0] : 'en';

    switch (locale ) {
        case "ru":
        case "uk":
        case "be":
            return ['ru-RU', 'Russian'];

        case "es":
            return ['es-ES', 'Spanish'];

        case "de":
            return ['de-DE', 'German'];

        default: return ['en-US', 'English'];
    }
}